// import node module libraries
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Card, Container, Form, Button } from 'react-bootstrap';
import { useTranslation, Trans } from 'react-i18next';

// import sub components
import HeaderBreadcrumb from '../HeaderBreadcrumb';
import SupportForm from './SupportForm';
import SEO from 'components/marketing/seo/Seo';

// Import authentication components
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated';
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';

const HelpCenterSupport = () => {
	const { t } = useTranslation(); // useTranslation-Hook
	const auth = useAuthUser();
	const isAuthenticated = useIsAuthenticated();

	const breadcrumb = [
		{
			page: 'Help Center',
			link: '/marketing/help-center/'
		},
		{
			page: t('Create Service Ticket'),
			link: '#'
		}
	];

	return (
		<Fragment>
			<SEO
				title="Help Center Support"
				description="Erstelle ein Service Ticket für technischen Support oder Kundenservice. Unser Team hilft dir schnell & unkompliziert weiter."
				keywords="support saas plattform, service ticket multi channel e-commerce"
				canonical="https://haeppy.app/marketing/help-center/support"
			/>
			{/* header and breadcrumb */}
			<HeaderBreadcrumb title={t('Create Service Ticket')} breadcrumb={breadcrumb} />

			{/* support form  */}
			{isAuthenticated ? <SupportForm /> : 
				<Container>
					<Row>
						<Col md={{ offset: 2, span: 8 }} xs={12}>
							<div className="mt-3 d-flex justify-content-center">
								{/* form - submit a request */}
								<Card className="border">
									<Card.Body className="p-5">
										<h2 className="mb-4 fw-semi-bold">{t('You are not logged in')}</h2>
										<p className="mb-4">
											<Trans
												i18nKey="You must be logged in to create a service ticket. If you have an account, please log in first. Otherwise, please use our <0>contact form</0> for your request. Thank you very much!"
												components={[<Link to="/marketing/pages/contact" />]}
											/>
										</p>
										<div>
											<Button as={Link} to="/authentication/sign-in?redirect_uri=/marketing/help-center/support/" variant="primary" className="">
												{t('Sign-in')}
											</Button>
											<Button as={Link} to="/marketing/pages/contact" variant="outline-primary" className="ms-2">
												{t('Contact Form')}
											</Button>
										</div>
									</Card.Body>
								</Card>
							</div>
						</Col>
					</Row>
				</Container>
			}
		</Fragment>
	);
};
export default HelpCenterSupport;
